import parse from 'date-fns/parse';
import format from 'date-fns/format';

export const convertDateFormat = (dateString) => {
    const inputFormat = 'MM/dd/yyyy HH:mm';
    const outputFormat = "yyyy-MM-dd'T'HH:mm:ssxxx";

    const parsedDate = parse(dateString, inputFormat, new Date());
    const formattedDate = format(parsedDate, outputFormat);

    return formattedDate;
};
